import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpXsrfIntercepter } from "./httpxsrf-intercepter";
import { HTTP_INTERCEPTORS } from "@angular/common/http";


@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpXsrfIntercepter,
      multi: true
    }
  ]
})
export class HttpXsrfHandlerModule { }
